import cn from 'classnames'

import { type HTMLProps } from 'react'

import { Head } from '~/components/data-display/tables/homepage/Head'
import { Body } from '~/components/data-display/tables/homepage/Body'
import { getRouteApi } from '@tanstack/react-router'

interface HomepageTableProps extends HTMLProps<HTMLDivElement> {}

export function HomepageTable ({ className }: HomepageTableProps)
{
    const { stats } = getRouteApi('/').useLoaderData()

    return (
        <section id={'cryptocurrencies'} className={className}>
            <div
                className={cn(
                    'mb-2',
                    'flex flex-row justify-between items-center',
                    'px-4 py-3 rounded-lg border border-accent/10',
                    'font-medium text-base',
                    'md:hidden',
                )}
            >
                <h2 className={cn('block uppercase whitespace-nowrap overflow-hidden overflow-ellipsis', 'md:sr-only')}>
                    <span aria-hidden={true}>[</span><span className={'sr-only'}>Private </span>cryptocurrencies<span
                    aria-hidden={true}
                >]</span></h2>

                <p>{Object.keys(stats.coins).length}</p>
            </div>

            <div className={cn('overflow-x-auto')}>
                <table className={'table uppercase'}>
                    <Head />

                    <Body />
                </table>
            </div>
        </section>
    )
}